import type { PopulateRunTimeFactories } from '../../libs/layouts/initPopulate';
import { ModelType } from '../../libs/layouts/populateLayouts/types/models';
import { RuntimeType } from '../../libs/layouts/populateLayouts/types/RuntimeType';
import { OutOfLivesButtonView } from '../../game/views/common/OutOfLivesButtonView';
import type { App } from '../App';

export function getPopulateFactories(app: App): PopulateRunTimeFactories {
  return {
    [ModelType.Container]: {
      [RuntimeType.OutOfLivesButtonView]: () => new OutOfLivesButtonView(app.stateController),
    },
    [ModelType.Sprite]: {},
    [ModelType.Text]: {},
  };
}
